import { render, staticRenderFns } from "./ShareWH.vue?vue&type=template&id=1337cab2&"
import script from "./ShareWH.vue?vue&type=script&lang=js&"
export * from "./ShareWH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports